import React from 'react'
import styles from '../registration/registration.module.scss'
import { Field } from 'formik'
import classNames from 'classnames'

interface Props {
  name: string
  label: string
  className?: string
}

const FormCheckbox = ({ name, label, className = '' }: Props) => {
  return (
    <div className={classNames(styles.wtnCheckbox, className)}>
      <Field name={name}>
        {({ field }) => {
          return (
            <>
              <input id={name} type='checkbox' checked={field.value} {...field} />
              <span className={styles.checkbox} aria-checked={field.value}></span>
              <label htmlFor={name} className={styles.commsLabel}>
                {label}
              </label>
            </>
          )
        }}
      </Field>
    </div>
  )
}

export default FormCheckbox
